<template>
  <div class="ce">
    <div>
      <span class="ce__title">Column Editor</span>
    </div>
    <div class="ce__row">
      <div>
        <div>
          <input
            id="select-all-checkbox"
            type="checkbox"
            :checked="allSelected"
            @change="toggleAll(allSelected)"
          >
          <label
            class="ce__checkbox-label"
            for="select-all-checkbox"
          >Select All</label>
        </div>
      </div>
    </div>
    <div class="ce__row">
      <div class="ce__column">
        <div
          v-for="(column, i) in columns"
          :key="i"
        >
          <input
            :id="column._column.field + '_column_checkbox'"
            type="checkbox"
            :data-field="column._column.field"
            :checked="column._column.visible"
            @change="toggle(column)"
          >
          <label
            class="ce__checkbox-label"
            :for="column._column.field + '_column_checkbox'"
          >{{ column._column.definition.title }}</label>
        </div>
      </div>
    </div>
    <div class="ce__row">
      <div class="ce__controls">
        <button
          class="ce__button ce__button_cancel"
          @click="close()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'BaseTabulatorColumnEditor',
  mixins: [BaseModalMixins],
  props: {
    table: {
      type: Object,
      required: true,
    },
    hiddenColumns: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      sections: []
    }
  },
  computed: {
    allSelected () {
      return this.table.getColumns().every(column => column._column.visible)
    },
    columns () {
      return this.table.getColumns().filter(column => !this.hiddenColumns.includes(column.getField()))
    },
    isGrouped () {
        return false
    },
    strategy () {
      return this.columns.filter(column => [
        'keyword',
        'score',
        'url',
        'section',
        'url_page_type',
        'url_status',
        'writing_status',
        'content_brief_status',
        'difficulty_score'
      ].includes(column._column.field))
    },
    rankingData () {
      return this.columns.filter(column => [
        'metric_rank_zone_current',
        'metric_rank',
        'rank_current_url',
        'url_match',
        'metric_rank_timestamp_current',
        'metric_rank_current'
      ].includes(column._column.field))
    },
    baselineData () {
      return this.columns.filter(column => [
        'metric_rank_timestamp_baseline',
        'metric_rank_zone_baseline',
        'metric_rank_baseline',
        'rank_baseline_url'
      ].includes(column._column.field))
    },
    serpFeatures () {
      return this.columns.filter(column => [
        'answer_box',
        'brand_pack',
        'image_pack',
        'knowledge_graph',
        'local_3_pack',
        'news_pack',
        'people_also_ask',
        'related_searches',
        'shopping_box',
        'video_pack',
        'ad_count',
        'geo',
        'locale',
        'total_number_of_results'
      ].includes(column._column.field))
    },
    searchVolume () {
      return this.columns.filter(column => [
        'metric_msv_broad_adjusted_1',
        'metric_msv_broad_adjusted_2',
        'metric_msv_broad_adjusted_3',
        'metric_msv_broad_adjusted_4'
      ].includes(column._column.field))
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    toggleAll (all) {
      this.table.blockRedraw()
      if (this.allSelected) {
        this.table.getColumns().forEach(column => {
          column.toggle()
        })
      } else {
        this.table.getColumns().forEach(column => {
          if (!column._column.visible) {
            column.toggle()
          }
        })
      }
      this.table.restoreRedraw()
    },
    toggle (column) {
      column.toggle()
    }
  }
}

</script>

<style scoped lang="scss">
input[type="checkbox"] {
    cursor: pointer;
}
.ce {

    &__title {
      display: block;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
      margin-bottom: 30px;
    }

    &__label {
      color: $rfx-dark-march;
      font-weight: 500;
    }

    &__checkbox-label:hover {
      cursor:pointer;
    }

    align-items: stretch;
    padding: 40px;

    &__label-wrapper {
      margin-top: 15px;
    }

    &__row {
      display: flex;
    }
    &__column {
      flex: 50%;
    }

    &__controls {
      margin-left: auto;
      order: 2;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_cancel {
        background-color: $rfx-medium-march;
        color: #fff;
      }
    }

}
.container {
    margin: auto;
    margin-top: 30px;
    width: 80%;
  }
</style>
